import { defineMessages } from 'react-intl';

export default defineMessages({
    removeMotorTrailerEquipmentDetails: {
        id: 'gateway.water-craft.Remove Motor, Trailer and Equipment Details?',
        defaultMessage: 'Remove Motor, Trailer and Equipment Details?'
    },
    defaultMotorTrailerEquipmentDetails: {
        id: 'gateway.water-craft.Are you Sure you want to remove this Motor, Trailer and Equipment details from the list?',
        defaultMessage: 'Are you Sure you want to remove this Motor, Trailer and Equipment details from the list?'
    },
    headingMotorTrailerEquipmentDetails: {
        id: 'gateway.water-craft.Motor / Trailer / Equipment - ',
        defaultMessage: 'Motor / Trailer / Equipment - '
    },
    hoAddAnotherWaterCraftDetails: {
        id: 'quoteandbind.views.watercraft.Add Another Motor, Trailer and Equipment Details?',
        defaultMessage: 'Add Another Motor, Trailer and Equipment Details?'
    },
    hoAddAdditionalWaterCraftBtn: {
        id: 'quoteandbind.views.watercraft.Add Motor Trailer Equipment Details',
        defaultMessage: 'Add Motor Trailer Equipment Details'
    },
    boatValue: {
        id: 'quoteandbind.ho.views.watercraft.Value',
        defaultMessage: 'Value'
    },
    boatHP: {
        id: 'quoteandbind.ho.views.watercraft.HP',
        defaultMessage: 'HP'
    },
    boatSpeed: {
        id: 'quoteandbind.ho.views.watercraft.Speed',
        defaultMessage: 'Speed'
    },
    boatVin: {
        id: 'quoteandbind.ho.views.watercraft.Serial/VIN',
        defaultMessage: 'Serial/VIN'
    },
    boatModel: {
        id: 'quoteandbind.ho.views.watercraft.Model',
        defaultMessage: 'Model'
    },
    boatMake: {
        id: 'quoteandbind.ho.views.watercraft.Make',
        defaultMessage: 'Make'
    },
    boatYear: {
        id: 'quoteandbind.ho.views.watercraft.Year',
        defaultMessage: 'Year'
    },
    motorType: {
        id: 'quoteandbind.ho.views.watercraft.Motor / Trailer / Equipment',
        defaultMessage: 'Motor / Trailer / Equipment'
    },
    yourHomePage: {
        id: 'quoteandbind.ho.views.watercraft.Motor, Trailer and Equipment Details',
        defaultMessage: 'Motor, Trailer and Equipment Details'
    },
    boatDescription : {
        id: "quoteandbind.ho.views.watercraft.Description",
        defaultMessage: "Description"
      }
});
